<div
  *transloco="let t; read: 'new-analysis-group'"
  class="xi-modal__container new-analysis-group__container"
>
  <h2 class="xi-modal__title">{{ inEditMode() ? t('title-edit') : t('title-create') }}</h2>

  <div class="xi-modal__content new-analysis-group__content">
    <xi-input-field
      [label]="t('name')"
      [placeholder]="t('enter-here')"
      [ngModel]="analysisGroupSelectionData().name"
      name="name"
      required
      [prePopulateStatus]="true"
      [status]="groupNameStatus()"
      (onChange)="onNameChange($event.detail.target.value)"
      appAutoFocus="xiInput"
    ></xi-input-field>
    <div>
      @if (isJourneyGroup()) {
        <div class="new-analysis-group__id-field-dropdown-wrapper">
          <div class="new-analysis-group__id-field-dropdown-label">
            <label for="default-id-field">{{ t('default-id-field') }}</label>
            <xi-icon
              icon="info"
              iconSize="small"
              color="CX"
              [tooltipProps]="{ text: t('default-id-field-tooltip') }"
            ></xi-icon>
          </div>
          <xi-dropdown
            inputId="default-id-field"
            [data]="journeyIdFields()"
            [ngModel]="analysisGroupSelectionData().journeyDefaultId"
            (onValueChange)="onJourneyDefaultIdChange($event)"
            name="idFields"
          ></xi-dropdown>
        </div>
      }
    </div>
    <div class="new-analysis-group__filter-file">
      @if (filterFile()?.lookupId) {
        <div class="new-analysis-group__filter-file-details">
          <div>
            <div>
              {{ t('filter-file-name', { name: filterFile().name }) }}
            </div>
            <div>
              {{ t('filter-file-ids', { count: filterFile().count }) }}
            </div>
          </div>
          <xi-icon-button
            icon="trash"
            [tooltip]="{ text: t('filter-file-remove') }"
            (onClick)="onFilterFileRemove()"
          ></xi-icon-button>
        </div>
      } @else {
        <app-file-upload
          size="x-small"
          mode="server"
          progressIndicator="bar"
          [dragDropText]="t('filter-file-dragdrop')"
          [buttonText]="t('filter-file-button')"
          [allowedExtensions]="['csv']"
          (fileAdded)="onFilterFileAdded($event)"
          (fileUploaded)="onFilterFileUploaded($event)"
          (fileError)="onFilterFileError()"
        ></app-file-upload>
      }
    </div>

    <xi-checkbox
      [label]="t('use-as-journey-group')"
      [(ngModel)]="isJourneyGroup"
      [disabled]="!!data().analysisGroup?.journeyGroupRule?.defaultField"
      (onChange)="onJourneyGroupChange()"
    ></xi-checkbox>

    <div class="new-analysis-group__collections-table-container">
      <table mat-table [dataSource]="tableDataSource" class="new-analysis-group__collections-table">
        <ng-container matColumnDef="collection">
          <th mat-header-cell *matHeaderCellDef>
            {{ t('collection') }}
          </th>

          <td
            mat-cell
            *matCellDef="let element; index as i"
            [attr.rowspan]="rowSpans()[i]"
            [style.display]="rowSpans()[i] === 0 ? 'none' : ''"
            [class.new-analysis-group__table-row--selected]="
              selectedCollections().includes(element.collectionName)
            "
          >
            {{ element.displayName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="configuration">
          <th mat-header-cell *matHeaderCellDef>
            {{ t('configuration') }}
          </th>

          <td mat-cell *matCellDef="let element">{{ element.analysis.configName }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ t('analysis-name') }}
          </th>

          <td mat-cell *matCellDef="let element">{{ element.analysis.displayName }}</td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>
            {{ t('date') }}
          </th>

          <td mat-cell *matCellDef="let element">
            {{ element.analysis.createdAt | lexDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="documents">
          <th class="download-center-table__documents-header" mat-header-cell *matHeaderCellDef>
            {{ t('documents') }}
          </th>

          <td mat-cell *matCellDef="let element">
            {{ element.analysis.documentCount | number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="filtered-documents">
          <th class="download-center-table__documents-header" mat-header-cell *matHeaderCellDef>
            {{ t('filtered-documents') }}
          </th>

          <td mat-cell *matCellDef="let element">
            {{ filteredDocumentsByAnalysis().get(element.analysis.name) ?? 0 | number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>

          <td mat-cell *matCellDef="let element">
            <div class="new-analysis-group__table-actions-container">
              @if (element.doesNotHaveDateData) {
                <xi-icon
                  icon="warning"
                  color="warning"
                  [tooltipProps]="{ text: t('collection-does-not-have-date-data') }"
                ></xi-icon>
              }
              @if (element.doesNotHaveJourneyId) {
                <xi-icon
                  icon="warning"
                  color="warning"
                  [tooltipProps]="{ text: t('collection-does-not-contain-id-field') }"
                ></xi-icon>
              }
              @if (element.doesNotHaveContentChannel) {
                <xi-icon
                  icon="warning"
                  color="warning"
                  [tooltipProps]="{ text: t('collection-does-not-have-content-channel') }"
                ></xi-icon>
              }

              <xi-checkbox
                [checked]="element.isSelected"
                color="orca"
                (click)="$event.preventDefault()"
              ></xi-checkbox>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns()"
          [class.new-analysis-group__table-row--selected]="row.isSelected"
          (click)="onAnalysisSelectionChanged(row, !row.isSelected)"
        ></tr>
      </table>
    </div>

    <div class="new-analysis-group__document-count">
      {{
        filterFile()?.lookupId
          ? t('filtered-document-count', { count: filteredDocumentCount() | number })
          : t('total-document-count', { count: selectedDocumentCount() | number })
      }}
    </div>
  </div>

  <div class="xi-modal__actions new-analysis-group__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>

    <div class="xi-loader-button-container">
      <xi-default-button
        [text]="inEditMode() ? t('confirm-edit') : t('confirm-create')"
        [tooltip]="saveDisabledTooltip() ? { text: saveDisabledTooltip() } : undefined"
        [tooltipDisplayOnDisabled]="true"
        [disabled]="isSaveDisabled() || isSaving()"
        (onClick)="saveGroup()"
      ></xi-default-button>

      @if (isSaving()) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>
  </div>

  @if (isFilterProcessing()) {
    <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
</div>
